import { CARD_ACTION_TYPES, CARD_TYPES } from '../../../constants';
import {
  extractIngredientsFromList,
  mergeLinkWithIngredients,
  prepareActionButton,
} from '../helpers';
import {
  getClickActivity,
  getCommonAnalyticsProps,
} from '../helpers/analytics';
import { analyticsProperties } from '../../../analytics/constants';

export const prepareCardData = cardData => {
  const hasSupportedItem = linkPropName => attribute =>
    !attribute?.[linkPropName]?.actionType ||
    attribute?.[linkPropName]?.actionType === CARD_ACTION_TYPES.LINK;

  return {
    cardId: cardData?.id,
    containerType: CARD_TYPES.TOOLS_AND_SUPPLIES,
    id: cardData?.id,
    supplies: cardData?.supplies
      .filter(hasSupportedItem('supplyLink'))
      .map((supply, index) => ({
        id: `${cardData.id}_supplies_${index}`,
        text: supply.supplyText || supply?.supplyLink?.actionText,
        ...(supply.supplyLink
          ? {
              analyticActionId: `${cardData.id}_supplies_${index}`,
              urlIngredients: prepareActionButton(supply.supplyLink)
                ?.urlIngredients,
            }
          : {}),
      })),
    tools: cardData?.tools
      .filter(hasSupportedItem('toolsLink'))
      .map((tool, index) => ({
        id: `${cardData.id}_tools_${index}`,
        text: tool.toolsText || tool?.toolsLink?.actionText,
        ...(tool.toolsLink
          ? {
              analyticActionId: `${cardData.id}_tools_${index}`,
              urlIngredients: prepareActionButton(tool.toolsLink)
                ?.urlIngredients,
            }
          : {}),
      })),
  };
};
export const prepareTranslations = (translationsStrings = {}) => ({
  suppliesLabel: translationsStrings.supplies_label,
  toolsLabel: translationsStrings.tools_label,
});

export const mergeProperties = ({ cardData, translations, urls }) => ({
  ...cardData,
  supplies: cardData.supplies.map(supply =>
    mergeLinkWithIngredients({ action: supply, property: 'url', urls }),
  ),
  suppliesLabel: translations.suppliesLabel,
  tools: cardData.tools.map(tool =>
    mergeLinkWithIngredients({ action: tool, property: 'url', urls }),
  ),
  toolsLabel: translations.toolsLabel,
});

export const getUrlIngredients = cardData => {
  return extractIngredientsFromList([
    ...cardData?.supplies,
    ...cardData?.tools,
  ]);
};

export { getBuyingToolsIngredients } from './common';

export const getAnalyticsPlacements = card => getCommonAnalyticsProps(card);

const buildAction = ({ property, card }) =>
  card[property]
    .filter(item => item?.urlIngredients)
    .map((item, index) => ({
      id: item.analyticActionId,
      [analyticsProperties.CLICK_ACTIVITY]: getClickActivity(
        item.urlIngredients.type,
        index,
        item.text,
      ),
    }));

export const getAnalyticsActions = card => [
  ...buildAction({ card, property: 'supplies' }),
  ...buildAction({ card, property: 'tools' }),
];
